import { render, staticRenderFns } from "./ApiLookupSectionedForm.vue?vue&type=template&id=32180d8a&scoped=true&"
import script from "./ApiLookupSectionedForm.vue?vue&type=script&lang=js&"
export * from "./ApiLookupSectionedForm.vue?vue&type=script&lang=js&"
import style0 from "./ApiLookupSectionedForm.vue?vue&type=style&index=0&id=32180d8a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32180d8a",
  null
  
)

export default component.exports